import React, { useState, useEffect } from 'react';
import logo from "../Assets/logo.jpg";
import useResponsive from '../hooks/useResponsive';

const LINKS = [
  { id: 'home', label: 'Home' },
  { id: 'courses', label: 'Courses' },
  { id: 'about', label: 'About' },
  { id: 'testimonials', label: 'Testimonials' },
  { id: 'contact', label: 'Contact' },
];

export default function Navbar({ scrollTo }) {
  const [scrolled, setScrolled] = useState(false);
  const [activeSection, setActiveSection] = useState('home');
  const [menuOpen, setMenuOpen] = useState(false);
  const { isMobile, isTablet } = useResponsive();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 40);
      const sections = LINKS.map(l => l.id);
      const offset = 80;
      for (let i = sections.length - 1; i >= 0; i--) {
        const el = document.getElementById(sections[i]);
        if (el && el.getBoundingClientRect().top <= offset) {
          setActiveSection(sections[i]);
          break;
        }
      }
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    if (menuOpen) {
      const close = () => setMenuOpen(false);
      window.addEventListener('scroll', close, { passive: true, once: true });
    }
  }, [menuOpen]);

  const handleNav = (id) => {
    scrollTo(id);
    setMenuOpen(false);
  };

  const showHamburger = isMobile || isTablet;

  return (
    <>
      <nav style={{
        position: 'fixed', top: 0, left: 0, right: 0, zIndex: 999,
        height: 66, padding: isMobile ? '0 16px' : '0 40px',
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        background: scrolled ? 'rgba(8,13,26,0.97)' : 'rgba(8,13,26,0.95)',
        backdropFilter: 'blur(20px)',
        borderBottom: '1px solid rgba(255,255,255,0.06)',
        transition: 'all 0.3s',
        fontFamily: "'DM Sans', sans-serif",
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, cursor: 'pointer' }} onClick={() => handleNav('home')}>
          <img src={logo} alt="Trinity Global" style={{ width: 38, height: 38, objectFit: 'contain', borderRadius: 8 }} />
          <span style={{ fontFamily: "'Outfit',sans-serif", fontWeight: 800, fontSize: isMobile ? 17 : 20, color: '#fff', letterSpacing: '-0.5px' }}>
            Trinity <span style={{ color: '#f97316' }}>Global</span>
          </span>
        </div>

        {!showHamburger && (
          <div style={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            {LINKS.map(l => (
              <button key={l.id}
                style={{ background: 'none', border: 'none', padding: '9px 17px', borderRadius: 9, fontFamily: "'DM Sans',sans-serif", fontSize: 13, fontWeight: 500, color: activeSection === l.id ? '#f97316' : '#94a3b8', cursor: 'pointer', transition: 'all 0.2s', borderBottom: activeSection === l.id ? '2px solid #f97316' : '2px solid transparent' }}
                onClick={() => handleNav(l.id)}
                onMouseEnter={e => { e.currentTarget.style.color = '#fff'; e.currentTarget.style.background = 'rgba(255,255,255,0.06)'; }}
                onMouseLeave={e => { e.currentTarget.style.color = activeSection === l.id ? '#f97316' : '#94a3b8'; e.currentTarget.style.background = 'none'; }}
              >{l.label}</button>
            ))}
          </div>
        )}

        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          {!showHamburger && (
            <button
              style={{ background: 'linear-gradient(135deg,#f97316,#ea580c)', border: 'none', padding: '10px 24px', borderRadius: 11, fontFamily: "'DM Sans',sans-serif", fontSize: 13, fontWeight: 600, color: '#fff', cursor: 'pointer', transition: 'all 0.25s' }}
              onClick={() => handleNav('contact')}
              onMouseEnter={e => { e.currentTarget.style.boxShadow = '0 6px 22px rgba(249,115,22,0.4)'; e.currentTarget.style.transform = 'translateY(-1px)'; }}
              onMouseLeave={e => { e.currentTarget.style.boxShadow = 'none'; e.currentTarget.style.transform = 'none'; }}
            >Enroll Now</button>
          )}
          {showHamburger && (
            <button onClick={() => setMenuOpen(o => !o)}
              style={{ background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: 10, width: 42, height: 42, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 5, cursor: 'pointer', padding: 0 }}>
              {[0,1,2].map(i => (
                <span key={i} style={{ display: 'block', width: 20, height: 2, borderRadius: 2, background: '#e2e8f0', transition: 'all 0.3s', transform: menuOpen ? (i===0?'rotate(45deg) translate(5px,5px)':i===2?'rotate(-45deg) translate(5px,-5px)':'scaleX(0)') : 'none', opacity: menuOpen && i===1 ? 0 : 1 }} />
              ))}
            </button>
          )}
        </div>
      </nav>

      {showHamburger && (
        <div style={{ position: 'fixed', top: 66, left: 0, right: 0, zIndex: 998, background: 'rgba(8,13,26,0.98)', backdropFilter: 'blur(20px)', borderBottom: '1px solid rgba(255,255,255,0.06)', overflow: 'hidden', maxHeight: menuOpen ? 420 : 0, transition: 'max-height 0.35s ease' }}>
          <div style={{ padding: '12px 16px 20px' }}>
            {LINKS.map(l => (
              <button key={l.id} onClick={() => handleNav(l.id)}
                style={{ display: 'block', width: '100%', textAlign: 'left', background: activeSection===l.id?'rgba(249,115,22,0.08)':'none', border: 'none', borderLeft: activeSection===l.id?'3px solid #f97316':'3px solid transparent', padding: '13px 16px', borderRadius: 10, fontFamily: "'DM Sans',sans-serif", fontSize: 15, fontWeight: 500, color: activeSection===l.id?'#f97316':'#94a3b8', cursor: 'pointer', marginBottom: 4 }}
              >{l.label}</button>
            ))}
            <button onClick={() => handleNav('contact')}
              style={{ marginTop: 8, width: '100%', background: 'linear-gradient(135deg,#f97316,#ea580c)', border: 'none', padding: '13px 24px', borderRadius: 11, fontFamily: "'DM Sans',sans-serif", fontSize: 14, fontWeight: 600, color: '#fff', cursor: 'pointer' }}>
              Enroll Now 🚀
            </button>
          </div>
        </div>
      )}
    </>
  );
}
